<template>
  <div />
</template>

<script>
  export default {
    name: 'Packages',

    data: () => ({
    }),
  }
</script>
